import React, { useEffect } from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form-new';
import { StudyGroupFormData } from './StudyGroupForm';
import { Phase } from 'models/training-group/training-group';
import { Button, Label, Select, TextInput } from 'components';
import { useTranslation } from 'react-i18next';
import { mqList } from 'enums/mq-list';

export const PhasesForm = ({ phases }: { phases: Phase[] }) => {
    const { control, register, formState, getValues } = useFormContext<StudyGroupFormData>();
    const [t] = useTranslation(['admin-validation', 'info', 'validation']);

    const { errors } = formState;

    const {
        append: appendField,
        remove: removeField,
        fields,
        replace: replaceFields,
    } = useFieldArray({
        control,
        name: 'phases',
    });
    useEffect(() => {
        if (phases && phases.length > 0) {
            replaceFields(phases);
        }
    }, [phases, replaceFields]);
    return (
        <div className="phase-container">
            <Button
                buttonClass="primary"
                type="button"
                handleClick={() => appendField({ providerId: '', description: '' })}
            >
                {t('info:add-phase')}
            </Button>
            <div>
                {fields.map((item, idx) => (
                    <div key={`${item.id}-${idx}`} className="phase-item">
                        <input type="hidden" value={item.id} name={`phases.${idx}.id`} />
                        <TextInput
                            defaultValue={item.description}
                            label={t('info:description')}
                            id="description"
                            reg={register(`phases.${idx}.description`, {
                                required: {
                                    value: true,
                                    message: t('validation:required-field'),
                                },
                                maxLength: {
                                    value: 355,
                                    message: t('validation:max-length', {
                                        maxLength: 355,
                                    }),
                                },
                            })}
                            errorMessage={errors.phases ? (errors.phases[idx]?.description?.message as string) : ''}
                        />
                        <fieldset className="form-group">
                            <Label labelText={t('info:providerId')} labelFor="" />
                            <div className="phase-label">
                                <Controller
                                    control={control}
                                    name={`phases.${idx}.providerId`}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: t('validation:required-field'),
                                        },
                                        validate: {
                                            uniqueProviderId: (value) => {
                                                const currentPhases = getValues('phases') || [];
                                                const count =
                                                    currentPhases.filter(
                                                        (phase) => phase?.providerId === value && value !== ''
                                                    )?.length ?? 0;
                                                return count <= 1 || t('validation:duplicate-provider-id');
                                            },
                                        },
                                    }}
                                    defaultValue={item.providerId}
                                    render={({ field: { onChange } }) => (
                                        <Select
                                            options={mqList}
                                            onChange={(v) => onChange(v[0]?.value)}
                                            values={[mqList?.find((r) => r.value === item.providerId) ?? mqList[0]]}
                                            errorMessage={
                                                errors.phases ? (errors.phases[idx]?.providerId?.message as string) : ''
                                            }
                                        />
                                    )}
                                />
                            </div>
                        </fieldset>
                        <Button
                            buttonClass="primary phase-button"
                            type="button"
                            pSize="small"
                            handleClick={() => removeField(idx)}
                        >
                            {t('info:delete-phase')}
                        </Button>
                    </div>
                ))}
            </div>
        </div>
    );
};
